import { ICreatedRecordParameters, IEntityMinimalModel } from "../../../../api/GenericTypes";
import { toValidDate } from "../../../datetime/DateTimeFormatter";

export interface IEnteredRecordEntityForm {
  enteredByIds?: IEntityMinimalModel[] | undefined | null;
  enteredFrom?: Date | undefined | null;
  enteredTo?: Date | undefined | null;
}

export const EnteredRecordEntityDefaultFilterFormValues: Required<IEnteredRecordEntityForm> = {
  enteredByIds: null,
  enteredFrom: null,
  enteredTo: null,
};

export const enteredRecordEntityFormToFilters = <Filters extends Partial<ICreatedRecordParameters>>(
  form: IEnteredRecordEntityForm
): Filters => {
  let filters = {} as Filters;
  filters.enteredByIds =
    Array.isArray(form.enteredByIds) && form.enteredByIds.length > 0 ? form.enteredByIds?.map((d) => d.id) : null;
  filters.enteredFrom = toValidDate(form.enteredFrom);
  filters.enteredTo = toValidDate(form.enteredTo);
  return filters;
};

export const enteredRecordEntityFiltersToForm = (
  filters: Partial<ICreatedRecordParameters>
): IEnteredRecordEntityForm => {
  return {
    enteredByIds: filters.enteredByIds ? filters.enteredByIds.map((id) => ({ id, name: "" })) : null,
    enteredFrom: filters.enteredFrom ? new Date(filters.enteredFrom) : null,
    enteredTo: filters.enteredTo ? new Date(filters.enteredTo) : null,
  };
};
